import { ref, watch } from 'vue'
import { scrollToTopOfPage } from '@/lib/scrolling'
import { useUrlSearchParams } from '@vueuse/core'


const isSearchPage = ref(false)
const isBusySearching = ref(true)

const params = useUrlSearchParams('history')

const displaySearchTerm = ref(params.searchTerm as string ?? '')
const inputSearchTerm = ref(params.searchTerm as string ?? '')
const searchTerm = ref(params.searchTerm as string ?? '')

const pageNumber = ref(params.pageNumber ? parseFloat(params.pageNumber as string) : 1)

export const useFaqContext = () => {
    watch([searchTerm, pageNumber], ([newSearchTerm, newPageNumber], [oldSearchTerm, oldPageNumber]) => {
        scrollToTopOfPage()
        // If user is paginating with the same search term, updating the pageNumber params in the url
        if (newSearchTerm.toLowerCase() === oldSearchTerm.toLowerCase() && newPageNumber !== oldPageNumber) {
            const url = new URL(window.location.href)
            url.searchParams.set('pageNumber', pageNumber.value.toString())
            window.history.replaceState(null, '', url.toString())
        }
    })

    watch(isBusySearching, (val) => {
        if (!val) {
            displaySearchTerm.value = searchTerm.value
        }
    })

    return {
        searchTerm,
        displaySearchTerm,
        inputSearchTerm,
        pageNumber,
        isSearchPage,
        isBusySearching,
    }
}